import ForgotPasswordContainer from "../containers/ForgotPasswordContainer";

const ForgotPasswordPage = () => {
    return <ForgotPasswordContainer />;
};

export default ForgotPasswordPage;
